<template>
    <div class="form-group">
        <label class="form-label section-title">{{ $t('messages.display_viewability') }}</label>
        <div class="viewability-setting">
            <div class="checkbox-container">
                <label class="checkbox">
                    <input type="checkbox" v-model="localData.viewability" @change="updateData" />
                    <span class="checkbox-label">{{ $t('messages.buy_impressions_with') }}</span>
                </label>
            </div>
            <div class="value-input-group">
                <input type="number" class="form-input" v-model="localData.viewability_percentage"
                    @input="validateViewabilityPercentage" @blur="validateViewabilityPercentage" min="0" max="100"
                    step="1" />
                <span class="percentage-symbol">%</span>
            </div>
            <span class="viewability-text">{{ $t('messages.predicted_viewability') }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "Viewability",
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            localData: {
                viewability: false,
                viewability_percentage: 0
            }
        };
    },
    watch: {
        data: {
            handler(newData) {
                if (newData) {
                    this.localData.viewability = newData.viewability || false;
                    this.localData.viewability_percentage = newData.viewability_percentage || 0;
                    this.validateViewabilityPercentage();
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        validateViewabilityPercentage() {
            let value = parseFloat(this.localData.viewability_percentage);

            if (isNaN(value)) {
                this.localData.viewability_percentage = 0;
            } else if (value < 0) {
                this.localData.viewability_percentage = 0;
            } else if (value > 100) {
                this.localData.viewability_percentage = 100;
            } else {
                this.localData.viewability_percentage = Math.round(value);
            }

            this.updateData();
        },

        updateData() {
            this.$emit('update', {
                viewability: this.localData.viewability,
                viewability_percentage: this.localData.viewability_percentage
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.viewability-setting {
    display: flex;
    align-items: center;
    gap: 12px;

    .value-input-group {
        .form-input {
            width: 80px;
            text-align: center;
        }
    }

    .viewability-text {
        font-size: 14px;
        color: #495057;
    }
}
</style>

